import { useStore } from '../providers/Store';

export const useIsLoading = () => {
  const store = useStore();
  return store.player.view.loading === true;
};
